
import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import BarcodeSystemModule from "@/store/modules/barcodeSystem";
import { UpdateBarcodeNoScanLineItemRequest } from "@/models/api/barcodeSystem/barcodeOrders/updateBarcodeNoScanLineItem";
import { formatBool } from "@/utils";

const barcodeSystemModule = getModule(BarcodeSystemModule);

@Component
export default class BarcodeNoScanLineItemUpdate extends Vue {
  @Prop({ default: false })
  loading: boolean;

  @Prop({ default: null })
  updateBarcodeNoScanLineItemRequest: UpdateBarcodeNoScanLineItemRequest;

  @Prop({default: null})
  validationMessages: string[];

  get deliveryExceptionOptions() : Array<any> {
    return this.updateBarcodeNoScanLineItemRequest && this.updateBarcodeNoScanLineItemRequest.deliveryExceptionOptions ? 
      this.updateBarcodeNoScanLineItemRequest.deliveryExceptionOptions.map(x => ({ label: x == null ? "" : x, value: x })) :
      [];
  }

  get formatDamaged()
  {
    return formatBool(this.updateBarcodeNoScanLineItemRequest.damaged);
  }

  set formatDamaged(val)
  {

  }

  formatBool(val)
  {
    formatBool(val)
  }
  
  handleDamagedChanged() {
    if(this.updateBarcodeNoScanLineItemRequest.damaged)
    {
      this.updateBarcodeNoScanLineItemRequest.quantityDamaged = this.updateBarcodeNoScanLineItemRequest.quantity;
    }
    else
    {
      this.updateBarcodeNoScanLineItemRequest.quantityDamaged = 0;
      this.updateBarcodeNoScanLineItemRequest.damageComment = null;
    }
  }
}
